import React from 'react';

import { Row, Col, Form as AntForm } from 'antd';
import { Form as FormikForm } from 'formik';

import styled from 'styled-components';

import FormikObserver from '@components/Gui/NwForm/FormikObserver';

const AntFormItem = AntForm.Item;

const StyledForm = styled(FormikForm)`
    width: 100%;

    &.padded {
        padding: 2em 2.5em;
    }

    .nw-form-item-container {
        .ant-form-item {
            margin-bottom: 0.5rem;

            .ant-form-item-label {
                padding: 0 0 0.5em 0;
                text-transform: uppercase;
                font-size: 0.8rem;
                height: auto;

                label {
                    height: auto;
                    font-size: 0.85rem;

                    font-weight: 400;
                    color: ${(props) => props.theme.TextColorMuted};

                    &.ant-form-item-required {
                        &::before {
                            content: none;
                            display: none;
                            margin: 0;
                        }

                        &::after {
                            align-self: center;
                            display: block;
                            flex: 0 0 0.4rem;
                            content: '';
                            height: 0.4rem;
                            width: 0.4rem;
                            line-height: 0;
                            margin: 0 0 0 0.25em;
                            border-radius: 0.25em;
                            background-color: ${(props) => props.theme.DangerColor};
                            position: static;
                            top: auto;
                        }
                    }
                }
            }

            .ant-form-item-control {
                .ant-form-item-extra {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    color: ${(props) => props.theme.TextColorMuted};
                    line-height: 1.25em;
                }

                .ant-form-item-control-input-content {
                    > .ant-segmented:not(.ant-segmented-block) {
                        display: flex;
                        max-width: 100%;
                        width: fit-content;
                    }
                }
            }

            .char-counter-container {
                font-size: 0.75rem;
                text-align: right;
                padding: 0.25em 1em;
                position: absolute;
                right: 0;
                top: -20px;
            }

            .ant-form-item-explain {
                font-size: 0.8rem;
                text-transform: uppercase;
                padding: 0.25em 1em;
                opacity: 0.75;
            }

            &.ant-form-item-has-error {
                .ant-btn {
                    border-color: ${(props) => props.theme.DangerColor} !important;
                    color: ${(props) => props.theme.DangerColor} !important;

                    &:hover,
                    &:focus {
                        border-color: ${(props) => props.theme.DangerColor} !important;
                        color: ${(props) => props.theme.DangerColor} !important;
                    }
                }

                .ant-select-arrow {
                    color: ${(props) => props.theme.DangerColor};
                }

                .ant-form-item-explain {
                    color: ${(props) => props.theme.DangerColor};
                    font-size: 0.75rem;
                    padding: 0;
                    opacity: 1;
                }
            }
        }

        &.inline {
            .ant-form-item-row {
                flex-direction: row !important;
                align-items: center;

                .ant-form-item-label {
                    padding: 0 1em 0 0;
                }
            }
        }
    }
`;

const NwFormButtonsBar = ({ left, right, marginTop = '.5em' }) => {
    return (
        <Row justify="space-between" style={{ margin: `${marginTop} 0 1em 0` }}>
            <Col>{left || <span></span>}</Col>
            <Col>{right || <span></span>}</Col>
        </Row>
    );
};

const NwForm = ({
    horizontal,
    inline,
    padded,
    small,
    children,
    values = {},
    disabledFields,
    onFinish,
    onTouchForm,
}) => {
    const getClassName = () => {
        let cn = 'ant-form';
        if (horizontal) {
            cn += ' ant-form-horizontal';
        } else {
            if (inline) {
                cn += ' ant-form-inline';
            } else {
                cn += ' ant-form-vertical';
            }
        }
        if (small) {
            cn += ' ant-form-small';
        }
        if (padded) {
            cn += ' padded';
        }
        return cn;
    };

    const handleTouchForm = (touchForm) => {
        if (onTouchForm) {
            onTouchForm(touchForm);
        }
    };

    const formSubmitProps = onFinish ? { onSubmit: onFinish } : {};

    return (
        <StyledForm noValidate className={getClassName()} {...formSubmitProps}>
            {children}
            <FormikObserver values={values} disabledFields={disabledFields} onChange={handleTouchForm} />
        </StyledForm>
    );
};

const NwFormItem = ({ label, control, required }) => {
    return (
        <div className="nw-form-item-container">
            <AntFormItem colon={false} label={label} required={required}>
                {control}
            </AntFormItem>
        </div>
    );
};

export { NwForm, NwFormButtonsBar, NwFormItem };
